import { SERVER_API_URL } from '../../app.constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { Principal } from 'src/app/core/auth/principal.service';



// type NewType = EntityResponseType;

@Injectable({ providedIn: 'root' })
export class InformationModelService {
    
    
    fromEffectiveDateFormatted: string;
    private resourceUrl = SERVER_API_URL + 'api/fetch-existed-information-details';

    constructor(private http: HttpClient, private principal: Principal) {
        this.fromEffectiveDateFormatted = this.principal.dateFormateClientToServerCDate();
    }

    fetchExistedInformationDetailsByType(form_data): Observable<any> {
        return this.http.post<any>(this.resourceUrl, form_data, { observe: 'response' })
    }

}
